import React, { Component } from "react";
import Navbar from "../components/Navbar";
import AppLayout from "../Layouts/AppLayout";
import {
    category,
    product
} from '../service/FirebaseService/CloundFireStore/model';

import {
  firebaseStorage
} from '../service/FirebaseService/Storage';
import { transFromToSelect, selectOptions } from '../Helper';
import Select from 'react-select';


export default class View1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: null,
      categories: [],
      product_image_url: null,
      category_documentId: null,
      price: null,
      unit: null,
      description: null
    };
  }

  async componentWillMount() {
    let categories = await category.getAll();
    const { documentId } = this.props.match.params;
    if (categories.length !== 0) {
      categories = categories.map((category) => {
        return transFromToSelect(category.title, category.documentId);
      });
    }

    
    let data = await product.getById(documentId);
    this.setState({ 
        categories,
        title: data.title,
        product_image_url: data.product_image_url,
        category_documentId: data.category_documentId,
        price: data.price,
        unit: data.unit,
        description: data.description
    });
  }

  handleGotoCreate = () => {
    this.props.history.push("/products/create");
  };

  handleInputChange = name => event => {
    this.setState({
      [name]: event.target.value
    });
  };

  handleSelectChange = name => object => {
    this.setState({
      [name]: object.value
    })
  }

  handleChangeFile = (name) => async (event) => {
    const response = await firebaseStorage.upload('images', event.target.files[0]);
    this.setState({
      [name]: response.url
    })
  }

  handleSuccess = () => {
    alert('edited product successfully!');
    this.props.history.push("/products");
  };

  handleSubmit = async event => {
    event.preventDefault();
    const { documentId } = this.props.match.params;
    const { title , category_documentId, unit, price, product_image_url, description } = this.state;
    const response = await product.updateById(documentId, { title , category_documentId, unit, price, product_image_url, description });
    if (response) {
      this.handleSuccess();
    }
  };

  render() {
    return (
      <div>
        <Navbar />
        <AppLayout>
          <div className="card card-default">
            <div className="card-header">Edit Products</div>
            <div className="card-body">
              <form onSubmit={this.handleSubmit}>
                <div className="form-group">
                  <label for="title">Title</label>
                  <input
                    onChange={this.handleInputChange("title")}
                    value={this.state.title}
                    type="text"
                    id="title"
                    className="form-control"
                    name="title"
                    placeholder="ชื่อสินค้า"
                  />
                </div>
                <div className="form-group">
                  <label for="title">ราคา</label>
                  <input
                    onChange={this.handleInputChange("price")}
                    placeholder="บาท"
                    value={this.state.price}
                    type="text"
                    id="price"
                    className="form-control"
                    name="price"
                  />
                </div>
                <div className="form-group">
                  <label for="unit">หน่วย</label>
                  <input
                    onChange={this.handleInputChange("unit")}
                    placeholder="หน่วย"
                    value={this.state.unit}
                    type="text"
                    id="unit"
                    className="form-control"
                    name="unit"
                  />
                </div>
                 <div className="form-group">
                  <label for="title">Category</label>
                  <Select value={selectOptions(this.state.category_documentId, this.state.categories)} onChange={this.handleSelectChange('category_documentId')} options={this.state.categories} />
                </div>
                <div className="form-group">
                  <label for="title">รายละเอียดสินค้า</label>
                  <textarea onChange={this.handleInputChange('description')} name="description" id="description" cols="5" rows="5" className="form-control" value={this.state.description} />
                </div>
                <div className="form-group">
                  <label for="unit">รูปสินค้า</label>
                  <input
                    onChange={this.handleChangeFile("product_image_url")}
                    type="file"
                    id="product_file"
                    className="form-control"
                    name="file"
                  />
                  {this.state.product_image_url ? (
                     <img src={this.state.product_image_url} class="img-fluid mt-2" alt="Responsive image" />
                  ) :''}
                 
                </div>
                <div class="form-group">
                  <button type="submit" className="btn btn-success">
                    Edit Products
                  </button>
                </div>
              </form>
            </div>
          </div>
        </AppLayout>
      </div>
    );
  }
}
